export default __webpack_public_path__ + "static/media/12week-Poster.77b54afc.png";